"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var Slide = function (_a) {
    var _b, _c;
    var game = _a.game;
    var config = (0, swr_hooks_1.useConfig)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.slideContainer },
        Object.keys(breakpoints).length > 0 &&
            !breakpoints.mobile &&
            !breakpoints.tablet && (react_1.default.createElement(ui_components_1.DesktopGameCard, { gameId: game.id, slug: game.slug, withDemo: ((_c = (_b = config === null || config === void 0 ? void 0 : config.features) === null || _b === void 0 ? void 0 : _b.gameDemo) === null || _c === void 0 ? void 0 : _c.desktop) ? true : false, title: game.title, gameCardPlaceholder: (config === null || config === void 0 ? void 0 : config.gameCardPlaceholder) || '', signUpModalKey: apps_shared_1.POPUP_CONSTANTS.SIGN_UP_MODAL })),
        Object.keys(breakpoints).length > 0 &&
            (breakpoints.mobile || breakpoints.tablet) && (react_1.default.createElement(ui_components_1.MobileGameCard, { title: game.title, gameId: game === null || game === void 0 ? void 0 : game.id, slug: game === null || game === void 0 ? void 0 : game.slug, gameCardPlaceholder: (config === null || config === void 0 ? void 0 : config.gameCardPlaceholder) || '', gameInfoModalKey: apps_shared_1.POPUP_CONSTANTS.GAME_INFO_MODAL }))));
};
exports.default = Slide;
